import { useState, useEffect } from 'react'
import { CButton, CCard, CCardBody, CRow, CCol, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CSpinner, CFormLabel, CFormInput } from '@coreui/react'

import Mastercarder from '../../components/shared/Mastercarder'
import Pageloader from '../../components/shared/Pageloader'
import CloudinaryUploader from '../../components/shared/CloudinaryUploader'
import SaveExtra from '../../services/general/saveExtraData.api'

const Miscellaneous = () => {
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [addEditModelVisible, setAddEditModelVisible] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [miscellaneousData, setMiscellaneousData] = useState([])
  const [miscellaneousName, setMiscellaneousName] = useState('')
  const [miscellaneousId, setMiscellaneousId] = useState(null)
  const [file, setFile] = useState([])

  const getData = async () => {
    setIsPageLoading(true)
    let data = await SaveExtra('Get_By_Type', 'Miscellaneous', '', '')
    data = JSON.parse(data.d)?.Data || []
    if (data) {
      data = data?.map((item) => {
        return {
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }
      })
    }
    setMiscellaneousData(data)
    setIsPageLoading(false)
  }

  const handleSubmitData = async (data) => {
    if (miscellaneousId) {
      await SaveExtra('Update', 'Miscellaneous', JSON.stringify(data), miscellaneousId)
    } else {
      await SaveExtra('Insert', 'Miscellaneous', JSON.stringify(data))
    }
    getData()
  }

  useEffect(() => {
    getData()
  }, [])
  const handleOnClick = () => {
    setAddEditModelVisible(true)
  }
  const handleEditMedication = (item) => {
    setAddEditModelVisible(true)
  }

  const handleDeleteFile = (id) => {
    setFile((prevFiles) => {
      if (prevFiles.length === 1) return []
      return prevFiles.filter((item, i) => item.id !== id)
    })
  }

  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    setFile((prevFiles) => {
      const isDuplicate = prevFiles.some((file) => file.url === url)

      if (isDuplicate) return prevFiles

      return [...prevFiles, { url, type, fileName, id, publicId }]
    })
  }

  const handleAddMiscellaneous = () => {
    const data = {
      name: miscellaneousName,
      file: file,
    }
    handleSubmitData(data)
    setAddEditModelVisible(false)
    setMiscellaneousName('')
    setFile([])
  }

  const handleEditMiscellaneousData = () => {
    const data = {
      name: miscellaneousName,
      file: file,
    }
    // const updatedData = miscellaneousData.map(item => {
    //     if (item.id === miscellaneousId) {
    //         return {
    //             ...item,
    //             name: miscellaneousName,
    //             file: file,
    //         };
    //     }
    //     return item;
    // });
    handleSubmitData(data)
    // setMiscellaneousData(updatedData);
    setAddEditModelVisible(false)
    setMiscellaneousName('')
    setFile([])
    setMiscellaneousId(null)
  }
  const handleDeleteMiscellaneous = async (id) => {
    await SaveExtra('DELETE', 'Miscellaneous', '', deleteVisibleId)
    setDeleteVisibleId(null)
    getData()
  }

  const handleEditMisc = (item) => {
    setMiscellaneousName(item.Data.name || '')
    setFile(item.Data.file || [])
    setMiscellaneousId(item.Id)
    setAddEditModelVisible(true)
  }

  return (
    <>
      <div className="position-relative patient-theme-page miscellaneous-theme">
        <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme" style={{ minHeight: '100vh', overflow: 'auto' }}>
          <CCard className="m-2 master-grid-theme__toolbar">
            <CCardBody className="w-100 master-grid-theme__toolbar-body">
              <div className="d-flex align-items-center justify-content-start gap-2">
                <CButton className="ui-action-btn ui-action-btn--primary" onClick={handleOnClick}>
                  + Add Miscellaneous
                </CButton>
              </div>
            </CCardBody>
          </CCard>

          <CRow className="p-2" xs={{ gutterX: 1 }}>
            {miscellaneousData.map((item, index) => {
              return (
                <CCol xs={4} key={index}>
                  <Mastercarder
                    deleteFunc={() => setDeleteVisibleId(item.Id)}
                    editFunc={() => handleEditMisc(item)}
                    heading={item.Data.name}
                  >
                    <CCardBody className="p-0"></CCardBody>
                  </Mastercarder>
                </CCol>
              )
            })}
          </CRow>

          <CModal visible={!!deleteVisibleId} className="patient-theme-modal" onClose={() => setDeleteVisibleId(null)}>
            <CModalHeader onClose={() => setDeleteVisibleId(null)}>
              <CModalTitle>Warning</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
            </CModalBody>
            <hr className="p-0 m-0" />
            <CModalFooter className="p-3 m-0">
              <CButton
                color="secondary"
                onClick={() => {
                  setDeleteVisibleId(null)
                }}
                className="ui-action-btn ui-action-btn--secondary"
              >
                Close
              </CButton>
              <CButton
                onClick={() => {
                  handleDeleteMiscellaneous(deleteVisibleId)
                }}
                className="ui-action-btn ui-action-btn--delete"
              >
                Delete
              </CButton>
            </CModalFooter>
          </CModal>

          <CModal
            visible={!!addEditModelVisible}
            className="patient-theme-modal"
            onClose={() => {
              setAddEditModelVisible(null)
              setFile([])
              setMiscellaneousName('')
            }}
          >
            <CModalHeader onClose={() => {
              setAddEditModelVisible(null)
              setFile([])
              setMiscellaneousName('')
            }}>
              <CModalTitle>{miscellaneousId ? 'Edit Miscellaneous' : 'Add Miscellaneous'}</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <div>
                <div>
                  <CFormLabel className="mt-3">Testing Name</CFormLabel>
                  <CFormInput type="text" value={miscellaneousName} onChange={(e) => setMiscellaneousName(e.target.value)} />
                </div>

                <div>
                  <CFormLabel className="mt-3">Add Image</CFormLabel>
                  <div className="d-flex gap-2 mt-2">
                    <CloudinaryUploader filesAl={file} onDelete={handleDeleteFile} onUploadSuccess={handleCloudinaryUpload} showStyleButton={true} />
                    <div className="d-flex flex-wrap gap-3">
                      {file.map((fileItem, fileIdx) => {
                        const fileUrl = fileItem.uploaded ? fileItem.url : fileItem.preview || fileItem.url
                        const fileType = fileItem.type || ''
                        const extension = fileUrl ? fileUrl.split('.').pop().toLowerCase() : ''

                        return (
                          <div key={fileIdx} className="d-flex flex-column align-items-center text-center">
                            {fileType === 'image' ? (
                              <div
                                style={{
                                  position: 'relative',
                                  width: '80px',
                                  height: '80px',
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  background: 'var(--ui-bg-inset)',
                                  border: '1px solid var(--ui-dashboard-border)',
                                }}
                                className="shadow"
                              >
                                <img
                                  src={fileUrl}
                                  alt={fileItem.fileName || 'Preview'}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  position: 'relative',
                                  width: '80px',
                                  height: '80px',
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  background: 'var(--ui-bg-inset)',
                                  border: '1px solid var(--ui-dashboard-border)',
                                }}
                                className="d-flex align-items-center justify-content-center shadow"
                              >
                                <a
                                  href={fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    textDecoration: 'none',
                                    color: 'var(--ui-text-primary)',
                                  }}
                                  className="d-flex align-items-center justify-content-center flex-column"
                                >
                                  <i className="bi bi-file-earmark-text" style={{ fontSize: '24px' }}></i>
                                  <p className="small m-0">{extension.toUpperCase() || 'FILE'}</p>
                                </a>
                              </div>
                            )}
                            <div
                              style={{
                                width: '100px',
                                height: '24px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                marginTop: '5px',
                              }}
                            >
                              <a
                                href={fileItem.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  display: 'inline-block',
                                  maxWidth: '100%',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  padding: '2px 6px',
                                  backgroundColor: 'var(--ui-bg-inset)',
                                  color: 'var(--ui-text-primary)',
                                  borderRadius: '4px',
                                  fontSize: '0.75rem',
                                  fontWeight: '600',
                                  textDecoration: 'none',
                                  border: '1px solid var(--ui-dashboard-border)',
                                }}
                              >
                                {fileItem.fileName || 'File'}
                              </a>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </CModalBody>
            <hr className="p-0 m-0" />
            <CModalFooter className="p-3 m-0">
              <CButton
                color="secondary"
                onClick={() => {
                  setAddEditModelVisible(null)
                  setFile([])
                  setMiscellaneousName('')
                }}
                className="ui-action-btn ui-action-btn--secondary"
              >
                Close
              </CButton>
              <CButton
                onClick={() => {
                  miscellaneousId ? handleEditMiscellaneousData() : handleAddMiscellaneous()
                }}
                className="ui-action-btn ui-action-btn--primary"
              >
                {miscellaneousId ? 'Update' : 'Add'}
              </CButton>
            </CModalFooter>
          </CModal>

          <Pageloader isLoading={isPageLoading} />
        </div>
      </div>
    </>
  )
}

export default Miscellaneous
